Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-sales-registration-system'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    var $informationWrapper = $('.information-container', $wrapper);
    var $gridWrapper = $('.grid-container', $wrapper);
    var $gridInventory = $('.grid-inventory', $gridWrapper);
    var $gridMyNetwork = $('.grid-mynetwork', $gridWrapper);

    var datasourceInventory;
    var datasourceMyNetwork;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("SalesRegistrationSystem", model);
        wrapper.bind(html);
        wrapper.loading(false);
    };

    wrapper.updateGridInventory = function () {
        wrapper.loading(true);
        
        wrapper.loading(false);
    };
    wrapper.updateGridMyNetwork = function () {
        wrapper.loading(true);
        
        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);
        $informationWrapper = $('.information-container', $wrapper);
        $gridWrapper = $('.grid-container', $wrapper);
        $gridInventory = $('.grid-inventory', $gridWrapper);
        $gridMyNetwork = $('.grid-mynetwork', $gridWrapper);
        initTabPanel($wrapper);
    };

    Vendd.MessageBus.subscribe(Vendd.SalesRegistrationSystem.Messages.GetModelSuccess, wrapper, function (envelope) {        

        model = envelope.message.data.data;
        wrapper.update();

        var wnd, noteTemplate;

        if ($gridInventory.length > 0) {            

            datasourceInventory = new kendo.data.DataSource({                
                data: model.Items,
                pageSize: 10,
                sort: [{ field: "ModelNumber", dir: "asc" }]
            });

            $gridInventory.kendoGrid({
                dataSource: datasourceInventory,
                sortable: true,
                filterable: {
                    mode: "row"
                },
                filter: function (e) {
                    if (e.filter == null) {
                        $('.clear-filters', $gridInventory).addClass("hidden");
                    } else {
                        $('.clear-filters', $gridInventory).removeClass("hidden");
                    }
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    buttonCount: 5
                },
                columns: [                    
                    { field: "ModelNumber", title: model.Literals.ModelNo },
                    { field: "VinNumber", title: model.Literals.VinNo },
                    { field: "Dealer", title: model.Literals.Dealer },
                    { field: "Location", title: model.Literals.Location },
                    { field: "SaleDate", title: model.Literals.SaleDate },
                    { field: "UniqueProductCode", title: model.Literals.UniqueProductCode },
                    {
                        dataItem: this,
                        headerTemplate: "<a href='javascript:void(0)' class='clear-filters hidden'><span class='btn-title'>" + model.Literals.ClearFilters + "</span><span class='icon icon-exit'></span></a>",
                        width: '160px',
                        command: [
                            {                                
                                template: "<a href='popup-notes' style='margin-left:6px;' class='btn btn-primary k-grid-btnOpenNotes js-fancybox'><span class='icon icon-attachment'></span></a>",
                                className: "",
                                name: "btnOpenNotes",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
                                    wnd.content(noteTemplate(dataItem));
                                    wnd.center().open();
                                }
                            },
                            {
                                template: "<a href='javascript:void(0)'style='margin-left:6px;' class='btn btn-primary k-grid-btnOpenUrl'><span class='icon icon-preferences'></span></a>",
                                       
                                className: "",
                                name: "btnOpenUrl",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    if (data.Url)
                                        window.open(data.Url, '_blank');
                                    else
                                        alert(model.Literals.SavedConfiguration);
                                }
                            },
                            {
                                template: "<a href='javascript:void(0)'style='margin-left:6px;' class='btn btn-primary k-grid-btnOpenPdf'><span class='icon icon-download'></span></a>",

                                className: "",
                                name: "btnOpenPdf",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    if (data.GlobalId)
                                        window.open('/Uploads/PDF/Configurator/' + data.ProductItemId + '/' + data.GlobalId + '.pdf', '_blank');
                                    else
                                        alert(model.Literals.MissingPdfFile);
                                }
                            }
                        ]
                    }
                ],
                dataBound: function (e) {
                                        
                    var data = this.dataSource.view();

                    for (var i = 0; i < data.length; i++) {
                        var dataItem = data[i];
                        var $tr = $gridInventory.find("[data-uid='" + dataItem.uid + "']");
                       
                        if (!dataItem.CanDelete) {
                            $('.k-grid-btnDelete', $tr).prop('disabled', 'disabled').addClass('disabled').addClass("hidden");
                        } else {
                            $('.k-grid-btnDelete', $tr).prop('disabled', '').removeClass('disabled').removeClass('hidden');
                        }
                    }
                }
            });

            $('.clear-filters', $gridInventory).on("click", function () {
                datasourceInventory.filter({});
                datasourceInventory.sort([{ field: "ModelNumber", dir: "asc" }]);
                $gridInventory.data("kendoGrid").setDataSource(datasourceInventory);
                $('.clear-filters', $gridInventory).addClass("hidden");
            });

            wnd = $("#popup-notes")
                .kendoWindow({
                    title: model.Literals.Notes,
                    modal: true,
                    visible: false,
                    resizable: true,
                    width: 300
                }).data("kendoWindow");

            noteTemplate = kendo.template($("#template-notes").html());
        }

        if ($gridMyNetwork.length > 0) {
            datasourceMyNetwork = new kendo.data.DataSource({
                data: model.MyNetworkItems,
                pageSize: 10,
                serverPaging: false,
                serverFiltering: false,
                sort: { field: "Dealer", dir: "asc" }
            });
            $gridMyNetwork.kendoGrid({
                dataSource: datasourceMyNetwork,
                sortable: true,
                filterable: {
                    mode: "row"
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    buttonCount: 5
                },
                columns: [
                    { field: "Dealer", title: model.Literals.Dealer },
                    { field: "Location", title: model.Literals.Location, filterable: false },
                    { field: "Quantity", title: model.Literals.Quantity, filterable: false },
                    {
                        command: [
                            {
                                template: "<a class='btn btn-primary k-grid-btnView'><span class='btn-title'>" + model.Literals.ViewInventory + "</span><span class='icon icon-arrow-right'></span></a>",
                                className: "",
                                name: "btnView",
                                click: function(e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    if (!data.UserId || data.UserId < 0) {
                                        kendo.alert("Invalid Action");
                                        return;
                                    }
                                    var filterData = _.filter(model.Items, function (i) { return i.UserId == data.UserId; });
                                    var datasource = new kendo.data.DataSource({
                                        data: filterData,
                                        pageSize: 10,
                                        sort: [{ field: "ModelNumber", dir: "asc" }]
                                    });
                                    $gridInventory.data("kendoGrid").setDataSource(datasource);
                                    $('.clear-filters', $gridInventory).removeClass("hidden");
                                    $("[data-tab-index='0']", $wrapper).trigger("click");
                                }
                            }
                        ]
                    }
                ]
            });
        }

    });

    Vendd.MessageBus.subscribe(Vendd.SalesRegistrationSystem.Messages.GetModelFailed, wrapper, function (envelope) {
        wrapper.loading(false);
    });
    
    Vendd.MessageBus.publishAsync(wrapper, new Vendd.SalesRegistrationSystem.Messages.GetModel());

});
